import { render } from "./orariPrenotazioneModal.vue?vue&type=template&id=769d694d&scoped=true&ts=true"
import script from "./orariPrenotazioneModal.vue?vue&type=script&lang=ts"
export * from "./orariPrenotazioneModal.vue?vue&type=script&lang=ts"

import "./orariPrenotazioneModal.vue?vue&type=style&index=0&id=769d694d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769d694d"]])

export default __exports__